module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_search-f2334e4101f1d9c5ceeec7539ca71cd0.png";